import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merge class names (Tailwind-safe) — used by shadcn / lucide-animated style components. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
